// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalError_header__3Mc92","footer":"ModalError_footer__2ta7e"};